import { Injectable, inject } from '@angular/core';

import { CreateMembershipRequest } from '@api/backend-connector/models';
import { MembershipsApi } from '@api/backend-connector/services';

export const isProjectMembership = (memberId: string, membership: { memberId: string; projectId?: string | null }) => {
  return membership.memberId === memberId && !!membership.projectId;
};

@Injectable({
  providedIn: 'root',
})
export class MembershipsService {
  private readonly membershipsApi = inject(MembershipsApi);

  createMembership2(request: CreateMembershipRequest) {
    return this.membershipsApi.createMembership({ body: request });
  }

  deleteMembership2(params: { id: string }) {
    return this.membershipsApi.deleteMembership(params);
  }
}
